import React, { useRef } from "react";
import { Icon, Text, Tooltip } from "@showitinc/showit-wc";
import HelpTooltip from "./HelpTooltip";
import slugify from "../utils/SlugifyUtils";
import uiPrefix from "../utils/UiPrefixUtils";
import openRowContextMenu from "../utils/openRowContextMenu";
import styles from "./PropertiesPanelCanvasSetSection.module.css";
import LayerPanelSiteCanvasSetMenu from "./sitepanel/LayersPanel/LayerPanelSiteCanvasSetMenu";

const PropertiesPanelCanvasSetSection = ({
  caret,
  children,
  helpTooltip,
  label,
  toggleVisibility,
  visible = true,
  blockContainer,
}) => {
  const section = visible ? children : null;
  const headerIcon = visible && helpTooltip ? <HelpTooltip tooltipKey={helpTooltip} /> : null;
  const headerRef = useRef();

  return (
    <div className={styles["header-panel-wrapper"]}>
      <div
        ref={headerRef}
        data-e2e={uiPrefix(`${slugify(label)}-header-panel`)}
        className={styles.root}
        onClick={toggleVisibility}
        onContextMenu={(e) =>
          openRowContextMenu({ event: e, rowEl: headerRef.current, active: true })
        }
      >
        <div className={styles.label}>
          {caret && (
            <Icon
              type={visible ? "caretDown" : "caretRight"}
              size="20"
              className={styles["caret-icon"]}
            />
          )}
          <Tooltip position="top-right">
            <span slot="content">
              <Text>{label}</Text>
            </span>

            <div className={styles.text}>{label}</div>
          </Tooltip>
          {headerIcon}
        </div>
        <LayerPanelSiteCanvasSetMenu blockContainer={blockContainer} />
      </div>
      <div className={styles["properties-panel-content-wrapper"]}>{section}</div>
    </div>
  );
};

export default PropertiesPanelCanvasSetSection;
